import { API_URL } from "constants/index";
import { fetchWithAuth } from "./fetch-with-auth";

// Legacy endpoint - uses Resource entity
const RESOURCE_URL_LEGACY = `${API_URL}/resource/all`;

// New endpoint - fetches directly from actual entities
const RESOURCE_URL_DIRECT = `${API_URL}/resource/all-direct`;

// New search endpoint
const RESOURCE_SEARCH_DIRECT = `${API_URL}/resource/search-direct`;

export const fetchResourcesFromAPI = async (session: any) => {
  try {
    const response = await fetchWithAuth(RESOURCE_URL_DIRECT, { method: 'GET' }, session);

    if (!response.ok) {
      throw new Error(`Failed to fetch resources: ${response.statusText}`);
    }

    const resources = await response.json();
    return resources;
  } catch (error) {
    console.error(error);
    throw error;  
  }
};

export const searchResourcesFromAPI = async (session: any, query: string, filter?: string, metadataFilter?: string) => {
  try {
    const params = new URLSearchParams();
    params.append('query', query);
    if (filter) params.append('filter', filter);
    if (metadataFilter) params.append('metadataFilter', metadataFilter);

    const response = await fetchWithAuth(
      `${RESOURCE_SEARCH_DIRECT}?${params.toString()}`, 
      { method: 'GET' }, 
      session
    );

    if (!response.ok) {
      throw new Error(`Failed to search resources: ${response.statusText}`);
    }

    const resources = await response.json();
    return resources;
  } catch (error) {
    console.error(error);
    throw error;  
  }
};

// Legacy function for backward compatibility
export const fetchResourcesFromAPILegacy = async (session: any) => {
  try {
    const response = await fetchWithAuth(RESOURCE_URL_LEGACY, { method: 'GET' }, session);

    if (!response.ok) {
      throw new Error(`Failed to fetch tasks: ${response.statusText}`);
    }

    const tasks = await response.json();
    return tasks;
  } catch (error) {
    console.error(error);
    throw error;  
  }
};
